export enum UserStep {
  NEXT = "next",
  PREV = "prev",
  VERIF = "verify",
  SIGN = "sign",
  REJECT = "reject",
  UPDATE = "update",
  EXIT = "exit",
}
